import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Badge, Alert, Table, Accordion, Spinner, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ModalNuevaSuscripcion from './Modales/ModalNuevaSuscripcion';
import ModalSeguroCancelarSuscripcion from './Modales/ModalSeguroCancelarSuscripcion';
// Modal de recuperar eliminado temporalmente: no se permite recuperar suscripciones canceladas
import ModalConfirmarPagoManual from './Modales/ModalConfirmarPagoManual';
import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { useToast } from 'context/providers/ToastProvider';

const SeccionSuscripciones = ({
    idCliente
}) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [suscripciones, setSuscripciones] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [ordenesSuscripcion, setOrdenesSuscripcion] = useState({});
    const [cargandoOrdenes, setCargandoOrdenes] = useState({});
    const [paginaOrdenes, setPaginaOrdenes] = useState({});
    const [hasMoreOrdenes, setHasMoreOrdenes] = useState({});
    const [totalOrdenes, setTotalOrdenes] = useState({});
    const [showModalNuevaSuscripcion, setShowModalNuevaSuscripcion] = useState(false);
    const [linkCopiado, setLinkCopiado] = useState({});
    const [cancelandoId, setCancelandoId] = useState(null);
    const [showModalCancelar, setShowModalCancelar] = useState(false);
    const [suscripcionACancelar, setSuscripcionACancelar] = useState(null);
    // Estados para recuperar suscripción eliminados temporalmente
    const [productosOrdenPrincipal, setProductosOrdenPrincipal] = useState({});
    const [cargandoProductos, setCargandoProductos] = useState({});
    const [licenciasServidor, setLicenciasServidor] = useState({});
    
    // Estados para pago manual
    const [showModalPagoManual, setShowModalPagoManual] = useState(false);
    const [suscripcionAPagar, setSuscripcionAPagar] = useState(null);
    const [ordenPendienteAPagar, setOrdenPendienteAPagar] = useState(null);
    const [procesandoPago, setProcesandoPago] = useState(false);
    const [estadoPagoSuscripcion, setEstadoPagoSuscripcion] = useState({
        dSaldoRestante: 0,
        dSumaPagos: 0,
        bTodasOrdensPagadas: false
    });

    /**
     * Formatea una fecha al formato [DD Mes YYYY]
     * Ejemplo: [15 Ene 2026]
     */
    const formatearFecha = (fecha) => {
        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const date = new Date(fecha);
        const dia = date.getDate();
        const mes = meses[date.getMonth()];
        const anio = date.getFullYear();
        return `${dia} ${mes} ${anio}`;
    };

    /**
     * Obtiene las suscripciones del cliente
     */
    const obtenerSuscripcionesCliente = async () => {
        setCargando(true);

        try {

            const response = await fetch(`/api/Suscripciones/ObtenerSuscripciones?idCliente=${idCliente}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {

                const data = await response.json();

                if (data.iResponseType === 1) {
                    let detalles = [];
                    let licenciasServidorMap = {};

                    try {
                        const ObjDetalles = JSON.parse(data.detalles);

                        // Patrón estándar del SP: siempre será un objeto con tablas
                        detalles = ObjDetalles.table2 || [];

                        // 🆕 Procesar Table3 con licencias servidor vinculadas
                        if (ObjDetalles.table3 && Array.isArray(ObjDetalles.table3)) {
                            ObjDetalles.table3.forEach(licServidor => {
                                licenciasServidorMap[licServidor.idSuscripcion] = {
                                    idLicenciaServidor: licServidor.idLicenciaServidor,
                                    vUUIDLicenciaServidor: licServidor.vUUIDLicenciaServidor,
                                    vTipoLicenciaServidor: licServidor.vTipoLicenciaServidor
                                };
                            });
                        }
                    } catch (parseError) {
                        console.error('Error parsing detalles:', parseError);
                        detalles = [];
                    }

                    setSuscripciones(detalles);
                    setLicenciasServidor(licenciasServidorMap);

                    // Inicializar estados para cada suscripción
                    const initialStates = {};
                    detalles.forEach(suscripcion => {
                        const id = suscripcion.idSuscripcion.toString();
                        initialStates[id] = [];
                    });

                    setOrdenesSuscripcion(initialStates);

                    // Inicializar paginación y hasMore para cada suscripción
                    const initialPagination = {};
                    const initialHasMore = {};
                    const initialTotal = {};
                    detalles.forEach(suscripcion => {
                        const id = suscripcion.idSuscripcion.toString();
                        initialPagination[id] = 1;
                        initialHasMore[id] = true;
                        initialTotal[id] = 0;
                    });

                    setPaginaOrdenes(initialPagination);
                    setHasMoreOrdenes(initialHasMore);
                    setTotalOrdenes(initialTotal);

                } else {
                    showErrorToast(data.vMessage);
                }

            } else {
                console.error('❌ Response not OK:', response.status, response.statusText);
                showErrorToast(`Error ${response.status}: ${response.statusText}`);

                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('❌ Error completo:', error);
            showErrorToast('Hubo un problema con la petici&oacute;n: ' + error.message);
        }

        setCargando(false);
    };

    /**
     * Obtiene más órdenes para el scroll infinito
     */
    const fetchMoreOrdenes = async (idSuscripcion) => {
        try {
            setCargandoOrdenes(prev => ({ ...prev, [idSuscripcion]: true }));

            const requestBody = {
                idSuscripcion: idSuscripcion,
                pagina: paginaOrdenes[idSuscripcion] || 1,
                tamanioPagina: 5
            };

            const response = await fetch('/api/Suscripciones/ObtenerOrdenesSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const nuevasOrdenes = parsed.table2 || [];
                    const total = parsed.table3?.[0]?.totalOrdenes || 0;

                    setTotalOrdenes(prev => ({ ...prev, [idSuscripcion]: total }));

                    if (nuevasOrdenes && nuevasOrdenes.length > 0) {
                        if (paginaOrdenes[idSuscripcion] === 1) {
                            setOrdenesSuscripcion(prev => ({
                                ...prev,
                                [idSuscripcion]: nuevasOrdenes
                            }));
                        } else {
                            setOrdenesSuscripcion(prev => ({
                                ...prev,
                                [idSuscripcion]: [...(prev[idSuscripcion] || []), ...nuevasOrdenes]
                            }));
                        }

                        setPaginaOrdenes(prev => ({
                            ...prev,
                            [idSuscripcion]: (prev[idSuscripcion] || 1) + 1
                        }));

                        if (nuevasOrdenes.length < 5) {
                            setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                        }
                    } else {
                        setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                    }
                } else {
                    showErrorToast(data.vMessage);
                    setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
            }
        } catch (error) {
            showErrorToast('Error al obtener órdenes: ' + error.message);
            setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
        } finally {
            setCargandoOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Reinicia y carga las órdenes de una suscripción desde cero
     */
    const cargarOrdenesIniciales = async (idSuscripcion) => {
        // Resetear estados para esta suscripción
        setOrdenesSuscripcion(prev => ({ ...prev, [idSuscripcion]: [] }));
        setPaginaOrdenes(prev => ({ ...prev, [idSuscripcion]: 1 }));
        setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: true }));

        // Cargar primera página
        await fetchMoreOrdenes(idSuscripcion);
    };

    /**
     * Renderiza el badge del estatus de la suscripción
     */
    const renderBadgeEstatus = (suscripcionOrStatus) => {
        // Puede recibir el objeto suscripción o solo el iStatus
        let iStatus = typeof suscripcionOrStatus === 'object' ? suscripcionOrStatus.iStatus : suscripcionOrStatus;

        const estatusConfig = {
            0: { bg: 'warning', text: 'PENDIENTE' },
            1: { bg: 'success', text: 'ACTIVA' },
            2: { bg: 'danger', text: 'CANCELADA' },
            3: { bg: 'secondary', text: 'SUSPENDIDA' }
        };

        const config = estatusConfig[iStatus] || { bg: 'secondary', text: 'DESCONOCIDO' };

        // Si es cancelada y recibimos el objeto suscripción, calcular días restantes
        if (iStatus === 2 && typeof suscripcionOrStatus === 'object') {
            const sus = suscripcionOrStatus;
            // ✅ USAR dFinLicenciaUso (fecha fin de licencia) en lugar de dProximoPago
            // dFinLicenciaUso refleja solo los días pagados, no el próximo pago programado
            const fechaFinalStr = sus.dFinLicenciaUso || sus.dFechaFinalizacion || null;
            if (fechaFinalStr) {
                const fechaFinal = new Date(fechaFinalStr);
                const ahora = new Date();
                // normalizar horas
                fechaFinal.setHours(0,0,0,0);
                ahora.setHours(0,0,0,0);
                const diffMs = fechaFinal - ahora;
                const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

                if (dias > 0) {
                    return (
                        <Badge bg={config.bg} className="me-2">
                            {`Cancelación en ${dias} día${dias !== 1 ? 's' : ''}`}
                        </Badge>
                    );
                }
                // si ya venció, mostrar simplemente "CANCELADA"
            }
        }

        return (
            <Badge bg={config.bg} className="me-2">
                {config.text}
            </Badge>
        );
    };

    /**
     * Renderiza el badge del estatus de una orden
     */
    const renderBadgeEstatusOrden = (estatus) => {
        const estatusConfig = {
            'Pagada': { bg: 'success', text: 'PAGADA' },
            'Pendiente': { bg: 'warning', text: 'PENDIENTE' },
            'Cancelada': { bg: 'danger', text: 'CANCELADA' },
            'Procesando': { bg: 'info', text: 'PROCESANDO' }
        };

        const config = estatusConfig[estatus] || { bg: 'secondary', text: estatus };

        return (
            <Badge bg={config.bg} size="sm">
                {config.text}
            </Badge>
        );
    };

    /**
     * Renderiza la información de periodicidad
     */
    const renderPeriodicidad = (tipoSuscripcion) => {
        const key = (tipoSuscripcion || '').toString().toLowerCase();
        const periodicidadConfig = {
            'mensual': { icon: 'calendar-alt', color: 'text-primary', label: 'Mensual' },
            'trimestral': { icon: 'calendar-alt', color: 'text-info', label: 'Trimestral' },
            'semestral': { icon: 'calendar-alt', color: 'text-warning', label: 'Semestral' },
            'anual': { icon: 'calendar-alt', color: 'text-success', label: 'Anual' }
        };

        const config = periodicidadConfig[key] || { color: 'text-muted', label: tipoSuscripcion };

        return (
            <span className={config.color}>
                <FontAwesomeIcon icon={config.icon} className="me-1" />
                {config.label || tipoSuscripcion}
            </span>
        );
    };

    /**
     * Copia el link de pago al portapapeles usando el endpoint GetPaymentLink
     */
    const copiarLinkPago = async (vUUIDLinkPago, idSuscripcion) => {
        try {
            const response = await fetch(`/api/orden/GetPaymentLink?vUUIDLinkPago=${vUUIDLinkPago}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
                return null;
            });

            if (response && response.ok) {
                const data = await response.json();
                console.log('Data: ' + data.vMessage);

                if (data.iResponseType === 1) {
                    let copiadoExitoso = false;

                    // Método alternativo para iOS
                    try {
                        await navigator.clipboard.writeText(data.vMessage);
                        copiadoExitoso = true;
                    } catch (clipboardError) {
                        // Fallback para iOS usando un elemento temporal
                        const textArea = document.createElement('textarea');
                        textArea.value = data.vMessage;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        textArea.style.top = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            copiadoExitoso = true;
                        } catch (execError) {
                            console.error('Error al copiar con execCommand:', execError);
                        }

                        document.body.removeChild(textArea);
                    }

                    if (copiadoExitoso) {
                        setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: true }));

                        setTimeout(() => {
                            setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: false }));
                        }, 2000);
                    } else {
                        showErrorToast('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
                    }
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response?.status + ' ' + response?.statusText);
                console.log(response);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('Error al copiar al portapapeles:', error);
            showErrorToast('Error al obtener el enlace de pago');
        }
    };

    /**
     * Maneja la expansión de un accordion item
     */
    const handleAccordionExpand = (idSuscripcion) => {
        // Si no hay órdenes cargadas para esta suscripción, cargar iniciales
        if (!ordenesSuscripcion[idSuscripcion] || ordenesSuscripcion[idSuscripcion].length === 0) {
            cargarOrdenesIniciales(idSuscripcion);
        }

        // Si no hay productos cargados para esta suscripción, cargarlos
        if (!productosOrdenPrincipal[idSuscripcion]) {
            obtenerProductosOrdenPrincipal(idSuscripcion);
        }
    };

    /**
     * Obtiene los productos de la orden principal de una suscripción
     */
    const obtenerProductosOrdenPrincipal = async (idSuscripcion) => {
        try {
            setCargandoProductos(prev => ({ ...prev, [idSuscripcion]: true }));

            const response = await fetch(`/api/Suscripciones/ObtenerProductosOrdenPrincipal?idSuscripcion=${idSuscripcion}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const productos = parsed.table2 || [];

                    setProductosOrdenPrincipal(prev => ({
                        ...prev,
                        [idSuscripcion]: productos
                    }));
                } else {
                    showErrorToast(data.vMessage);
                    setProductosOrdenPrincipal(prev => ({
                        ...prev,
                        [idSuscripcion]: []
                    }));
                }
            } else {
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setProductosOrdenPrincipal(prev => ({
                    ...prev,
                    [idSuscripcion]: []
                }));
            }
        } catch (error) {
            showErrorToast('Error al obtener productos: ' + error.message);
            setProductosOrdenPrincipal(prev => ({
                ...prev,
                [idSuscripcion]: []
            }));
        } finally {
            setCargandoProductos(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Abre el modal de confirmación para cancelar suscripción
     */
    const abrirModalCancelar = (suscripcion) => {
        setSuscripcionACancelar(suscripcion);
        setShowModalCancelar(true);
    };

    /**
     * Cancela una suscripción
     */
    const cancelarSuscripcion = async () => {
        if (!suscripcionACancelar) return;

        try {
            setCancelandoId(suscripcionACancelar.idSuscripcion);

            const response = await fetch('/api/Suscripciones/CancelarSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: suscripcionACancelar.idSuscripcion,
                    motivoCancelacion: 'Cancelación solicitada desde el panel'
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Suscripción cancelada correctamente');
                    await obtenerSuscripcionesCliente(); // refrescar lista
                } else {
                    showErrorToast(data.vMessage || 'No fue posible cancelar la suscripción');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`${response.status} ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al cancelar la suscripción: ' + error.message);
        } finally {
            setCancelandoId(null);
            setShowModalCancelar(false);
            setSuscripcionACancelar(null);
        }
    };

    // Recuperación deshabilitada: una vez cancelada, no puede recuperarse

    /**
     * Determina si debe mostrarse el botón de pago y qué tipo
     * Retorna: { mostrar: boolean, esPrimerPago: boolean, ordenPendiente: object }
     */
    const determinarEstadoPago = (suscripcion) => {
        const ordenes = ordenesSuscripcion[suscripcion.idSuscripcion];
        
        // Si no hay órdenes cargadas, no mostrar botón
        if (!ordenes || ordenes.length === 0) {
            return { mostrar: false, esPrimerPago: false, ordenPendiente: null };
        }

        // REGLA 1: PRIMER PAGO
        // Solo debe tener la primera orden (orden principal) en PENDIENTE
        // No importa la fecha de vencimiento porque nunca se ha pagado
        const ordenPrincipal = ordenes.find(orden => orden.bEsOrdenPrimaria === 1);
        if (ordenPrincipal && ordenPrincipal.vEstatus === 'Pendiente') {
            return { 
                mostrar: true, 
                esPrimerPago: true, 
                ordenPendiente: ordenPrincipal 
            };
        }

        // REGLA 2: PAGO RECURRENTE
        // - La fecha de próximo pago debe estar vencida (menor a fecha actual)
        // - La orden principal NO debe estar en deuda (debe estar pagada)
        // - Ya debe tener 1 o más órdenes pagadas
        // NOTA: Puede tener una orden de renovación pendiente (con pagos parciales)
        //       o no tener orden (el backend la creará)
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0); // Resetear horas para comparación solo de fecha

        if (suscripcion.dProximoPago) {
            const fechaProximoPago = new Date(suscripcion.dProximoPago);
            fechaProximoPago.setHours(0, 0, 0, 0);

            const pagoVencido = true;//fechaProximoPago < fechaActual;
            const ordenPrincipalPagada = ordenPrincipal && ordenPrincipal.vEstatus === 'Pagada';
            const tieneOrdenesPagadas = ordenes.some(orden => orden.vEstatus === 'Pagada');

            if (pagoVencido && ordenPrincipalPagada && tieneOrdenesPagadas) {
                // Buscar si ya existe una orden de renovación pendiente
                // (puede tener pagos parciales)
                const ordenRenovacionPendiente = ordenes.find(
                    orden => orden.bEsOrdenPrimaria === 0 && orden.vEstatus === 'Pendiente'
                );

                return { 
                    mostrar: true, 
                    esPrimerPago: false, 
                    ordenPendiente: ordenRenovacionPendiente || null  // null solo si no existe, el backend la creará
                };
            }
        }

        return { mostrar: false, esPrimerPago: false, ordenPendiente: null };
    };

    /**
     * Abre el modal de confirmación para pago manual
     * Decide qué modal abrir según el tipo de pago de la suscripción
     */
    const abrirModalPagoManual = async (suscripcion) => {
        const estadoPago = determinarEstadoPago(suscripcion);

        if (!estadoPago.mostrar) {
            showErrorToast('No se cumplen las condiciones para realizar un pago en este momento');
            return;
        }

        // Solo validar orden pendiente si es PRIMER PAGO
        // Para pago recurrente, el backend creará la orden
        if (estadoPago.esPrimerPago && !estadoPago.ordenPendiente) {
            showErrorToast('No se encontró la orden principal para el primer pago');
            return;
        }

        setSuscripcionAPagar(suscripcion);
        setOrdenPendienteAPagar(estadoPago.ordenPendiente); // Puede ser null para pago recurrente

        // Obtener estado de pago completo desde el backend
        await obtenerEstadoPagoSuscripcion(suscripcion.idSuscripcion);

        // Siempre usar ModalConfirmarPagoManual (ahora con campos completos)
        setShowModalPagoManual(true);
    };

    /**
     * Obtiene el estado de pago completo de una suscripción
     * Retorna: saldo restante, suma de pagos, si todas las órdenes están pagadas
     */
    const obtenerEstadoPagoSuscripcion = async (idSuscripcion) => {
        try {
            const response = await fetch(`/api/Suscripciones/ObtenerEstadoPagoSuscripcion?idSuscripcion=${idSuscripcion}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const estado = await response.json();
                setEstadoPagoSuscripcion({
                    dSaldoRestante: estado.dSaldoRestante,
                    dSumaPagos: estado.dSumaPagos,
                    bTodasOrdensPagadas: estado.bTodasOrdensPagadas
                });
                return estado;
            } else {
                setEstadoPagoSuscripcion({
                    dSaldoRestante: 0,
                    dSumaPagos: 0,
                    bTodasOrdensPagadas: false
                });
                return null;
            }
        } catch (error) {
            console.error('Error al obtener estado de pago:', error);
            setEstadoPagoSuscripcion({
                dSaldoRestante: 0,
                dSumaPagos: 0,
                bTodasOrdensPagadas: false
            });
            return null;
        }
    };

    /**
     * Confirma y ejecuta el pago manual de la suscripción
     * @param {Object} dataForm - Datos del formulario de pago
     */
    const confirmarPagoManual = async (dataForm) => {
        if (!suscripcionAPagar) return;

        try {
            setProcesandoPago(true);

            // Convertir archivo a base64 si existe
            let archivoBase64 = null;
            let nombreArchivo = null;
            let tipoArchivo = null;
            
            if (dataForm.vArchivo) {
                const file = dataForm.vArchivo;
                nombreArchivo = file.name;
                tipoArchivo = file.type;
                
                // Convertir a base64
                const reader = new FileReader();
                archivoBase64 = await new Promise((resolve, reject) => {
                    reader.onload = () => {
                        // Remover el prefijo "data:...;base64,"
                        const base64 = reader.result.split(',')[1];
                        resolve(base64);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            }

            console.log('🔍 Datos de pago manual:', {
                idSuscripcion: suscripcionAPagar.idSuscripcion,
                idOrden: ordenPendienteAPagar?.idOrden || 0,
                monto: dataForm.dImportePagado,
                esPrimerPago: ordenPendienteAPagar !== null
            });

            const response = await fetch('/api/Suscripciones/RealizarPagoManualSuscripcionOtrosMetodos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: suscripcionAPagar.idSuscripcion,
                    idOrden: ordenPendienteAPagar?.idOrden || 0,
                    dImportePagado: Number.parseFloat(dataForm.dImportePagado),
                    idCatFormaPago: Number.parseInt(dataForm.idCatFormaPago),
                    dFechaPago: dataForm.dFechaPago,
                    vReferencia: dataForm.vReferencia,
                    vJsonDetallesLinkPago: JSON.stringify(dataForm.vJsonDetallesLinkPago || {}),
                    vArchivoBase64: archivoBase64,
                    vNombreArchivo: nombreArchivo,
                    vTipoArchivo: tipoArchivo
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Pago registrado correctamente');
                    
                    // Refrescar la lista de suscripciones y órdenes
                    await obtenerSuscripcionesCliente();
                    await fetchMoreOrdenes(suscripcionAPagar.idSuscripcion.toString());
                    
                    // Cerrar modal
                    setShowModalPagoManual(false);
                    setSuscripcionAPagar(null);
                    setOrdenPendienteAPagar(null);
                } else {
                    showErrorToast(data.vMessage || 'No fue posible registrar el pago');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al registrar el pago: ' + error.message);
        } finally {
            setProcesandoPago(false);
        }
    };

    useEffect(() => {
        console.log('🔍 SeccionSuscripciones mounted');
        console.log('🔍 idCliente:', idCliente);
        if (idCliente) {
            obtenerSuscripcionesCliente();
        }
    }, [idCliente]);

    return (
        <ErrorBoundary>
            <Card>
                <Card.Header>
                    <Row className="align-items-center">
                        <Col>
                            <h5 className="mb-0">
                                <FontAwesomeIcon icon="sync-alt" className="me-2 text-primary" />
                                Suscripciones
                            </h5>
                        </Col>
                        <Col xs="auto" className="d-flex align-items-center gap-2">
                            {suscripciones.length > 0 && (
                                <Badge bg="info" className="me-2">
                                    {suscripciones.length} suscripci&oacute;n{suscripciones.length !== 1 ? 'es' : ''}
                                </Badge>
                            )}
                            <Button
                                variant="success"
                                size="sm"
                                className="d-flex align-items-center"
                                onClick={() => setShowModalNuevaSuscripcion(true)}
                            >
                                <FontAwesomeIcon icon="plus" className="me-1" />
                                Nueva Suscripci&oacute;n
                            </Button>
                        </Col>
                    </Row>
                </Card.Header>

                <Card.Body className="border-top fs--1">
                    {cargando ? (
                        <div className="p-3">
                            <Row>
                                {[1, 2].map((item) => (
                                    <Col lg={6} key={item} className="mb-3">
                                        <div className="border rounded-3 p-3">
                                            <Skeleton height={20} width="60%" className="mb-2" />
                                            <Skeleton height={16} width="40%" className="mb-2" />
                                            <Skeleton height={14} width="80%" className="mb-2" />
                                            <Skeleton height={14} width="70%" />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ) : suscripciones.length > 0 ? (
                        <Accordion
                            defaultActiveKey=""
                            onSelect={(eventKey) => {
                                if (eventKey) {
                                    const suscripcionIndex = parseInt(eventKey);
                                    const suscripcion = suscripciones[suscripcionIndex];
                                    if (suscripcion) {
                                        handleAccordionExpand(suscripcion.idSuscripcion.toString());
                                    }
                                }
                            }}
                        >
                            {suscripciones.map((suscripcion, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index} className="mb-2">
                                    <Accordion.Header>
                                        <div className="w-100 d-flex justify-content-between align-items-center me-3">
                                            <div className="d-flex align-items-center">
                                                <Badge bg="primary" className="me-2">
                                                    #{suscripcion.idSuscripcion}
                                                </Badge>
                                                <span className="fw-bold">{suscripcion.vNombreSuscripcion}</span>
                                                <span className="ms-2">{renderBadgeEstatus(suscripcion)}</span>
                                            </div>
                                            <div className="text-end">
                                                <span className="fw-bold text-success">
                                                    ${parseFloat(suscripcion.dPrecio || 0).toLocaleString('es-MX', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} {suscripcion.vMoneda || 'MXN'}
                                                </span>
                                                    <div className="small text-muted">
                                                    {renderPeriodicidad(suscripcion.vTipoRenovacion)}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            {/* Columna izquierda: Información y Productos */}
                                            <Col lg={8}>
                                                <h6 className="fw-bold mb-3">
                                                    <FontAwesomeIcon icon="info-circle" className="me-2 text-info" />
                                                    Informaci&oacute;n de la Suscripci&oacute;n
                                                </h6>
                                                <Table size="sm" className="mb-3">
                                                    <tbody>
                                                        {suscripcion.iStatus === 2 ? (
                                                            <>
                                                                {(() => {
                                                                    // ✅ USAR dFinLicenciaUso (fecha fin de licencia) en lugar de dProximoPago
                                                                    // dFinLicenciaUso refleja solo los días pagados, no el próximo pago programado
                                                                    const fechaFinalStr = suscripcion.dFinLicenciaUso || suscripcion.dFechaFinalizacion || null;
                                                                    if (fechaFinalStr) {
                                                                        const fechaFinal = new Date(fechaFinalStr);
                                                                        const ahora = new Date();
                                                                        fechaFinal.setHours(0,0,0,0);
                                                                        ahora.setHours(0,0,0,0);
                                                                        const diffMs = fechaFinal - ahora;
                                                                        const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

                                                                        if (dias > 0) {
                                                                            return (
                                                                                <>
                                                                                    <tr>
                                                                                        <td className="border-0 ps-0 py-1">
                                                                                            <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Cancelación:</div>
                                                                                        </td>
                                                                                        <td className="border-0 py-1">
                                                                                            <span className="text-danger fw-bold">{`Cancelación en ${dias} día${dias !== 1 ? 's' : ''} (finaliza ${formatearFecha(fechaFinal)})`}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            );
                                                                        } else {
                                                                            // Si ya pasó la fecha, solo mostrar "Cancelada"
                                                                            return (
                                                                                <tr>
                                                                                    <td className="border-0 ps-0 py-1">
                                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Cancelación:</div>
                                                                                    </td>
                                                                                    <td className="border-0 py-1">
                                                                                        <span className="text-danger fw-bold">Cancelada</span>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        }
                                                                    }

                                                                    // Fallback: mostrar la fecha de actualización (fecha de cancelación solicitada)
                                                                    return (
                                                                        <tr>
                                                                            <td className="border-0 ps-0 py-1">
                                                                                <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Estado:</div>
                                                                            </td>
                                                                            <td className="border-0 py-1">
                                                                                <span className="text-danger fw-bold">
                                                                                    {suscripcion.dUpdatedDate ?
                                                                                        formatearFecha(new Date(suscripcion.dUpdatedDate)) :
                                                                                        'CANCELADA'
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })()}

                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Periodicidad:</div>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        {renderPeriodicidad(suscripcion.vTipoRenovacion)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Moneda:</div>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <span className="fw-bold">{suscripcion.vMoneda || 'MXN'}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Creada:</div>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <FontAwesomeIcon icon="clock" className="me-1 text-muted" />
                                                                        <span className="fw-bold text-muted">{formatearFecha(suscripcion.dFechaCreacion)}</span>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {/* Mostrar sólo información relevante; 'Licencia Principal' removida por requerimiento */}
                                                                {/* Nueva fila: Licencia Servidor Vinculada (solo para licencias Nube) */}
                                                                {suscripcion.vTipoLicencia?.includes("Nube") && (
                                                                    <tr>
                                                                        <td className="border-0 ps-0 py-1">
                                                                            <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Licencia Servidor:</div>
                                                                        </td>
                                                                        <td className="border-0 py-1">
                                                                            {licenciasServidor[suscripcion.idSuscripcion] && licenciasServidor[suscripcion.idSuscripcion].idLicenciaServidor ? (
                                                                                <Link
                                                                                    to={`/licencias/detalle/${licenciasServidor[suscripcion.idSuscripcion].idLicenciaServidor}`}
                                                                                    className="fw-600 text-decoration-none"
                                                                                >
                                                                                    <FontAwesomeIcon icon={faDesktop} className="me-1 text-primary" />
                                                                                    #{licenciasServidor[suscripcion.idSuscripcion].idLicenciaServidor} - Servidor

                                                                                </Link>
                                                                            ) : (
                                                                                <span className="text-warning">
                                                                                    <FontAwesomeIcon icon="unlink" className="me-1" />
                                                                                    Sin vinculación a servidor
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {suscripcion.iStatus === 1 && (
                                                                    <tr>
                                                                        <td className="border-0 ps-0 py-1">
                                                                            <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Pr&oacute;ximo pago:</div>
                                                                        </td>
                                                                        <td className="border-0 py-1">
                                                                            <span className="text-primary fw-bold">
                                                                                <FontAwesomeIcon icon="calendar-alt" className="me-1" />
                                                                                {suscripcion.dProximoPago ?
                                                                                    new Date(suscripcion.dProximoPago).toLocaleDateString('es-MX', {
                                                                                        day: '2-digit',
                                                                                        month: 'short',
                                                                                        year: 'numeric'
                                                                                    }) :
                                                                                    'N/A'
                                                                                }
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Periodicidad:</div>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        {renderPeriodicidad(suscripcion.vTipoRenovacion)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Moneda:</div>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <span className="fw-bold">{suscripcion.vMoneda || 'MXN'}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <div className="fw-bold text-muted" style={{ fontSize: '0.95rem' }}>Creada:</div>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <FontAwesomeIcon icon="clock" className="me-1 text-muted" />
                                                                        <span className="fw-bold text-muted">{formatearFecha(suscripcion.dFechaCreacion)}</span>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )}
                                                        {suscripcion.vUUIDLinkPago && suscripcion.iStatusLink === 0 && (
                                                            <tr>
                                                                <td className="border-0 ps-0 py-1">
                                                                    <div className="fw-bold text-dark" style={{ fontSize: '0.95rem' }}>Link de pago:</div>
                                                                </td>
                                                                <td className="border-0 py-1">
                                                                    <span
                                                                        className={`me-3 text-break ${linkCopiado[suscripcion.idSuscripcion] ? "text-secondary" : "text-primary"}`}
                                                                        style={{
                                                                            cursor: suscripcion.iStatusLink === 0 ? "pointer" : "default",
                                                                            transition: "color 0.2s ease"
                                                                        }}
                                                                        onClick={suscripcion.iStatusLink === 0 ? () => copiarLinkPago(suscripcion.vUUIDLinkPago, suscripcion.idSuscripcion) : undefined}
                                                                    >
                                                                        <span className="fw-bold">
                                                                            {linkCopiado[suscripcion.idSuscripcion]
                                                                                ? "¡Copiado!"
                                                                                : suscripcion.iStatusLink === 0
                                                                                    ? `Copiar link de pago`
                                                                                    : ``
                                                                            }
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            
                                                {/* Tabla de Productos de la Suscripción */}
                                                <h6 className="fw-bold mb-2">
                                                    <FontAwesomeIcon icon="box" className="me-2 text-primary" />
                                                    Productos de la Suscripción
                                                </h6>
                                                    {cargandoProductos[suscripcion.idSuscripcion] ? (
                                                        <div className="d-flex justify-content-center align-items-center py-3">
                                                            <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                            <small className="text-muted">Cargando productos...</small>
                                                        </div>
                                                    ) : productosOrdenPrincipal[suscripcion.idSuscripcion] && productosOrdenPrincipal[suscripcion.idSuscripcion].length > 0 ? (
                                                        <div className="table-responsive">
                                                            <Table size="sm" bordered hover className="mb-0">
                                                                <thead className="bg-light">
                                                                    <tr>
                                                                        <th className="border-200">Cód. Barras</th>
                                                                        <th className="border-200">Nombre Producto</th>
                                                                        <th className="border-200 text-center">Cantidad</th>
                                                                        <th className="border-200 text-end">Prec. Unit.</th>
                                                                        <th className="border-200 text-end">Importe</th>
                                                                        <th className="border-200 text-end">IVA</th>
                                                                        <th className="border-200 text-end">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {productosOrdenPrincipal[suscripcion.idSuscripcion].map((producto, idx) => (
                                                                        <tr key={idx}>
                                                                            <td className="align-middle">
                                                                                <small className="text-nowrap">{producto.vCodigoBarras}</small>
                                                                            </td>
                                                                            <td className="align-middle">
                                                                                <small>{producto.vNombreProducto}</small>
                                                                            </td>
                                                                            <td className="align-middle text-center">
                                                                                <small>{producto.dCantidad}</small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    {parseFloat(producto.dImporte).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    {parseFloat(producto.dImporte).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                                {producto.dDescuento > 0 && (
                                                                                    <>
                                                                                        <br />
                                                                                        <Badge bg="danger" size="sm">
                                                                                            -{parseFloat(producto.dDescuento).toLocaleString('es-MX', {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                                style: 'currency',
                                                                                                currency: 'MXN'
                                                                                            })}
                                                                                        </Badge>
                                                                                    </>
                                                                                )}
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    {parseFloat(producto.dIVA).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small className="fw-bold text-success">
                                                                                    {parseFloat(producto.dTotal).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot className="bg-light">
                                                                    <tr>
                                                                        <td colSpan="6" className="text-end fw-bold">
                                                                            <small>Total:</small>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <small className="fw-bold text-success">
                                                                                {productosOrdenPrincipal[suscripcion.idSuscripcion]
                                                                                    .reduce((sum, p) => sum + parseFloat(p.dTotal), 0)
                                                                                    .toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                            </small>
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            </Table>
                                                        </div>
                                                    ) : (
                                                        <Alert variant="light" className="text-center py-4 mb-0">
                                                            <FontAwesomeIcon icon="box-open" className="me-1" />
                                                            <div className="text-muted">No hay productos en la orden principal</div>
                                                        </Alert>
                                                    )}
                                            </Col>
                                            
                                            {/* Tercera columna: Órdenes Relacionadas */}
                                            <Col lg={4}>
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h6 className="fw-bold mb-0">
                                                        <FontAwesomeIcon icon="shopping-cart" className="me-2 text-success" />
                                                        &Oacute;rdenes Relacionadas
                                                        {totalOrdenes[suscripcion.idSuscripcion] > 0 && (
                                                            <Badge bg="primary" className="ms-2">
                                                                {totalOrdenes[suscripcion.idSuscripcion]}
                                                            </Badge>
                                                        )}
                                                    </h6>
                                                </div>

                                                <div
                                                    className="border rounded-3 p-2 bg-light"
                                                    style={{ maxHeight: '500px', overflowY: 'auto' }}
                                                    id={`scrollableTargetOrdenes-${suscripcion.idSuscripcion}`}
                                                >
                                                    {ordenesSuscripcion[suscripcion.idSuscripcion] && ordenesSuscripcion[suscripcion.idSuscripcion].length > 0 ? (
                                                        <InfiniteScroll
                                                            dataLength={ordenesSuscripcion[suscripcion.idSuscripcion].length}
                                                            next={() => fetchMoreOrdenes(suscripcion.idSuscripcion.toString())}
                                                            hasMore={hasMoreOrdenes[suscripcion.idSuscripcion] || false}
                                                            loader={
                                                                <div className="d-flex justify-content-center alignItems-center py-2">
                                                                    <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                                    <small className="text-muted">Cargando m&aacute;s &oacute;rdenes...</small>
                                                                </div>
                                                            }
                                                            scrollableTarget={`scrollableTargetOrdenes-${suscripcion.idSuscripcion}`}
                                                            scrollThreshold={0.70}
                                                            style={{ overflowX: 'hidden' }}
                                                            endMessage={
                                                                ordenesSuscripcion[suscripcion.idSuscripcion].length > 0 && (
                                                                    <div className="text-center py-2 border-top mt-2">
                                                                        <small className="text-muted">
                                                                            <FontAwesomeIcon icon="shopping-cart" className="me-1" />
                                                                            Sin m&aacute;s &oacute;rdenes
                                                                        </small>
                                                                    </div>
                                                                )
                                                            }
                                                        >
                                                            {ordenesSuscripcion[suscripcion.idSuscripcion].map((orden, ordenIndex) => (
                                                                <div key={ordenIndex} className={`pb-3 mb-3 ${ordenIndex < ordenesSuscripcion[suscripcion.idSuscripcion].length - 1 ? 'border-bottom' : ''}`}>
                                                                    <div className={`d-flex justify-content-between align-items-start p-2 rounded-3 ${orden.bEsOrdenPrimaria ? 'bg-primary bg-opacity-10 border border-primary border-opacity-25' : ''}`}>
                                                                        <div className="flex-grow-1">
                                                                            <div className="d-flex align-items-center">
                                                                                <Link to={`/ordenes/detalle/${orden.idOrden}`} className="fw-600 text-decoration-none d-block">
                                                                                    <FontAwesomeIcon icon="shopping-cart" className="me-1 text-primary" />
                                                                                    Orden #{orden.idOrden}
                                                                                </Link>
                                                                                {orden.bEsOrdenPrimaria === 1 && (
                                                                                    <Badge bg="primary" size="sm" className="ms-2">
                                                                                        <FontAwesomeIcon icon="star" className="me-1" />
                                                                                        INICIAL
                                                                                    </Badge>
                                                                                )}
                                                                            </div>
                                                                            <div className="small text-muted mt-1">
                                                                                <FontAwesomeIcon icon="calendar-alt" className="me-1" />
                                                                                {formatearFecha(orden.dFechaCreacion)}
                                                                            </div>
                                                                            {orden.vDescripcion && (
                                                                                <div className="small text-muted mt-1">
                                                                                    <FontAwesomeIcon icon="sticky-note" className="me-1" />
                                                                                    {orden.vDescripcion}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="text-end ms-3">
                                                                            {renderBadgeEstatusOrden(orden.vEstatus)}
                                                                            <div className="fw-bold text-success small mt-1">
                                                                                ${parseFloat(orden.dTotal || 0).toLocaleString('es-MX', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })} {orden.vMoneda || 'MXN'}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            ))}
                                                        </InfiniteScroll>
                                                    ) : cargandoOrdenes[suscripcion.idSuscripcion] ? (
                                                        <div className="d-flex justify-content-center align-items-center py-4">
                                                            <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                            <small className="text-muted">Cargando &oacute;rdenes...</small>
                                                        </div>
                                                    ) : (
                                                        <Alert variant="light" className="text-center py-4">
                                                            <FontAwesomeIcon icon="shopping-cart" size="2x" className="text-muted mb-2" />
                                                            <div className="text-muted">No hay &oacute;rdenes para esta suscripci&oacute;n</div>
                                                        </Alert>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        
                                        {/* Botones de acción */}
                                        <Row className="mt-3">
                                            <Col>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {suscripcion.iStatus !== 2 && (
                                                        <>
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                className="d-flex align-items-center"
                                                                onClick={() => abrirModalCancelar(suscripcion)}
                                                                disabled={cancelandoId === suscripcion.idSuscripcion || suscripcion.iStatus === 2}
                                                            >
                                                                {cancelandoId === suscripcion.idSuscripcion ? (
                                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                                ) : (
                                                                    <FontAwesomeIcon icon="ban" className="me-1" />
                                                                )}
                                                                {cancelandoId === suscripcion.idSuscripcion ? 'Cancelando...' : 'Cancelar Suscripción'}
                                                            </Button>

                                                            {/* Botón de Pago (forma de pago 99 o automáticas) */}
                                                            {(() => {
                                                                const estadoPago = determinarEstadoPago(suscripcion);
                                                                
                                                                if (!estadoPago.mostrar) return null;

                                                                return (
                                                                    <Button
                                                                        variant="success"
                                                                        size="sm"
                                                                        className="d-flex align-items-center"
                                                                        onClick={() => abrirModalPagoManual(suscripcion)}
                                                                        disabled={procesandoPago}
                                                                    >
                                                                        <FontAwesomeIcon icon="money-bill-wave" className="me-1" />
                                                                        {estadoPago.esPrimerPago ? 'Realizar Primer Pago' : 'Realizar Pago'}
                                                                    </Button>
                                                                );
                                                            })()}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <Alert variant="light" className="text-center py-4">
                            <FontAwesomeIcon icon="sync-alt" size="3x" className="text-muted mb-3" />
                            <h6 className="text-muted">No hay suscripciones registradas</h6>
                            <p className="text-muted mb-0">
                                Este cliente no tiene suscripciones activas o registradas en el sistema.
                            </p>
                        </Alert>
                    )}
                </Card.Body>

                {/* Modal Nueva Suscripción */}
                <ModalNuevaSuscripcion
                    show={showModalNuevaSuscripcion}
                    setShow={setShowModalNuevaSuscripcion}
                    idCliente={idCliente}
                    onSuscripcionCreada={obtenerSuscripcionesCliente}
                />

                {/* Modal Cancelar Suscripción */}
                <ModalSeguroCancelarSuscripcion
                    show={showModalCancelar}
                    onClose={() => {
                        setShowModalCancelar(false);
                        setSuscripcionACancelar(null);
                    }}
                    onConfirm={cancelarSuscripcion}
                    processing={cancelandoId !== null}
                    suscripcionInfo={suscripcionACancelar}
                />

                {/* Modal Confirmar Pago Manual (consolidado con todos los campos) */}
                <ModalConfirmarPagoManual
                    show={showModalPagoManual}
                    onHide={() => {
                        setShowModalPagoManual(false);
                        setSuscripcionAPagar(null);
                        setOrdenPendienteAPagar(null);
                        setEstadoPagoSuscripcion({
                            dSaldoRestante: 0,
                            dSumaPagos: 0,
                            bTodasOrdensPagadas: false
                        });
                    }}
                    suscripcion={suscripcionAPagar}
                    ordenPendiente={ordenPendienteAPagar}
                    procesando={procesandoPago}
                    onConfirmar={confirmarPagoManual}
                    estadoPago={estadoPagoSuscripcion}
                />


            </Card>
        </ErrorBoundary>
    );
};

SeccionSuscripciones.propTypes = {
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default SeccionSuscripciones;